import React from "react";
import styles from "./DisplayMode.module.scss";

import { RightSidebar, Menu, Canvas } from "..";

const DisplayMode: React.FC = () => {
  return (
    <div className={styles.display_mode}>
      <div className={styles.display_mode__container}>
        <Menu />
        <Canvas />
        <RightSidebar />
      </div>
    </div>
  );
};

export default DisplayMode;
